module.exports = __webpack_public_path__ + "static/img/gsjs_tu5.dda14bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gsjs_tu5.png
// module id = yuPq
// module chunks = 0